


























import { Component, Watch, Prop, ProvideReactive } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import commonMixins from "@mixins/commonNewMixins";
import questionSet from "./index.vue";
import questionSubmitSet from "../questionnaireSubmitSet/index.vue";
import templateTitleDialog from "./templateTitleDialog.vue";
import { QuestionnaireEditModule } from "@/modules/newCommunity/pages/operationTools/dynimicStore/newIndex";
import { service } from "@modules/newCommunity/setup";

type SubmitScene = "submit" | "template";

interface EditorState {
  activeIndex: number;
  isAnswerMode: boolean;
  isViewMode: boolean;
  submitLoading: boolean;
}

@Component({
  name: "QuestionnaireEditorCore",
  components: { questionSet, questionSubmitSet, templateTitleDialog },
})
export default class QuestionnaireEditorCore extends mixins(commonMixins) {
  @ProvideReactive()
  templateMode = false;

  @Prop({ default: true })
  active?: boolean;

  @Prop({ default: "" })
  questionnaireId?: string;

  @Prop({ default: "" })
  templateId?: string;

  @Prop({ default: "ADD" })
  openMode?: string;

  @Prop({ default: "" })
  editSpecialMode?: string;

  @Prop({ default: "QUESTIONNAIRE" })
  activityQuestionnaireType?: string;

  @Prop({ default: "QUESTIONNAIRE" })
  activityQuestionnaireProperty?: string;

  @Prop({ default: false })
  showVerificationConfig?: boolean;

  @Prop({
    default: () => {
      return {
        title: "自定义表单",
        label: "表单名称",
        type: "ACTIVITY",
      };
    },
  })
  surveyConfig?: any;

  private localSubmit = {};
  private postForm = {
    title: "标题",
  };
  private submitLoading = false;
  private activeIndex = 1;
  private dataInited = false;
  private templateTitleDialogVisible = false;
  private templateEditingId = "";

  get rules() {
    return {
      title: [{ required: true, type: "string", message: "请输入" + this.surveyConfig.label, trigger: "blur" }],
    };
  }

  get questionnaireType() {
    return QuestionnaireEditModule.questionnaireType;
  }

  get isAnswerMode() {
    return this.questionnaireType == "ANSWER";
  }

  get basicDataUniqueId() {
    return QuestionnaireEditModule.basicDataUniqueId;
  }

  get VUE_APP_WEN_LINK() {
    return process.env.VUE_APP_WEN_LINK;
  }

  private get basicData() {
    return QuestionnaireEditModule.basicData;
  }

  private get isModel() {
    return QuestionnaireEditModule.isModel;
  }

  @Watch("basicData", { deep: true, immediate: true })
  watchPropData() {
    if (JSON.stringify(this.basicData) != JSON.stringify(this.localSubmit)) {
      const backup = JSON.parse(JSON.stringify(this.basicData));
      this.localSubmit = JSON.parse(JSON.stringify(backup));
      this.postForm = backup;
      this.clearValidate();
    }
  }

  // 向外层同步步骤和模式状态，供两种承载层复用操作栏
  private emitStateChange() {
    const state: EditorState = {
      activeIndex: this.activeIndex,
      isAnswerMode: this.isAnswerMode,
      isViewMode: this.isModel === "VIEW",
      submitLoading: this.submitLoading,
    };
    this.$emit("state-change", state);
  }

  private setActiveIndex(activeIndex: number) {
    this.activeIndex = activeIndex;
    this.emitStateChange();
  }

  getFormInstance() {
    return this.$refs.postForm as any;
  }

  clearValidate() {
    if (this.getFormInstance()) {
      this.getFormInstance().clearValidate();
    }
  }

  // 初始化共享问卷状态，保持原弹窗的数据装载顺序
  async initQuestionnaire(questionnaireId: any = "") {
    this.dataInited = false;
    this.setActiveIndex(1);
    this.postForm.title = "";
    QuestionnaireEditModule.SET_RESET_STORE();
    QuestionnaireEditModule.SET_showVerificationConfig(this.showVerificationConfig);
    QuestionnaireEditModule.SET_isModel(this.openMode || "");
    QuestionnaireEditModule.SET_editSpecialMode(this.editSpecialMode || "");
    QuestionnaireEditModule.SET_QUESTIONNAIRESOURCE_DATA("DOCTOR");
    QuestionnaireEditModule.SET_QUESTIONTYPE_PROPERTY(this.activityQuestionnaireProperty as string);
    QuestionnaireEditModule.SET_QUESTIONTYPE_DATA(this.activityQuestionnaireType as string);

    if (questionnaireId || this.questionnaireId) {
      QuestionnaireEditModule.SET_BASICDATA_ID(questionnaireId || this.questionnaireId);
      await QuestionnaireEditModule.GET_QUESTIONNAIRE_DETAIL(questionnaireId || this.questionnaireId);
    }

    if (this.showVerificationConfig) {
      QuestionnaireEditModule.SET_verificationConfig_verificationLogicSwitch("INFO");
    } else {
      QuestionnaireEditModule.SET_verificationConfig_verificationLogicSwitch("DISABLE");
    }

    this.dataInited = true;
    this.emitStateChange();
  }

  async saveTemp() {
    if (this.isModel == "VIEW") {
      window.open(`${this.VUE_APP_WEN_LINK}/medic/nsurvey/${this.questionnaireId}?pageMode=preview`, "_blank", "height=800, width=375, top=0, left=0, toolbar=no, menubar=no, scrollbars=no, resizable=no, location=no, status=no");
      return;
    }

    const result = await (this as any).$refs.questionSet.CHECK_DATA_validate();
    if (!result) return;

    const saveRes: any = await QuestionnaireEditModule.SAVE_QUESTIONNAIRE(this.basicDataUniqueId || "");
    this.submitLoading = false;
    this.emitStateChange();
    if (saveRes && saveRes.data && saveRes.code == 200) {
      QuestionnaireEditModule.SET_BASICDATA_ID(saveRes.data);
      QuestionnaireEditModule.GET_QUESTIONNAIRE_DETAIL(saveRes.data);
      window.open(`${this.VUE_APP_WEN_LINK}/medic/nsurvey/${saveRes.data}?pageMode=preview`, "_blank", "height=800, width=375, top=0, left=0, toolbar=no, menubar=no, scrollbars=no, resizable=no, location=no, status=no");
    }
  }

  async nextStepToTemple() {
    let result = false;
    if (this.activeIndex == 2) {
      result = await (this as any).$refs.questionSet.CHECK_DATA_validate();
    }
    if (this.activeIndex == 3) {
      result = await (this as any).$refs.questionSubmitSet.CHECK_DATA_validate();
    }
    if (!result) return;

    this.templateEditingId = "";
    if (this.templateId) {
      const refreshNew = await this.$confirm("该表单已经创建过模板，请选择是否需要更新原模板", "提示", {
        confirmButtonText: "更新",
        cancelButtonText: "创建新模板",
        distinguishCancelAndClose: true,
        type: "warning",
      })
        .then(() => {
          return "update";
        })
        .catch((action: any) => {
          return action == "cancel" ? "new" : "close";
        });

      if (refreshNew == "update") {
        this.templateEditingId = this.templateId as string;
        await this.templateTitleDialogSuccess("");
      } else if (refreshNew == "new") {
        this.templateTitleDialogVisible = true;
      }
    } else {
      this.templateTitleDialogVisible = true;
    }
  }

  async templateTitleDialogSuccess(title: string) {
    const questionnaireId = await this.handleCommit("template");
    if (!questionnaireId) return;

    const templateRes = await service.questionnaireGenerationTemplate({
      questionnaireId,
      formTemplateId: this.templateEditingId,
      title: title || undefined,
    });
    this.$emit("template-success", templateRes.data, {
      questionnaireId,
      title: this.basicData.title,
    });
  }

  async nextStep() {
    if (this.activeIndex == 1) {
      const result = await (this.$refs.postForm as any).validate();
      if (result) {
        const backup = JSON.parse(JSON.stringify(this.postForm));
        QuestionnaireEditModule.SET_BASIC_LIST(backup);
        this.setActiveIndex(this.activeIndex + 1);
      }
      return;
    }

    if (this.activeIndex == 2) {
      const result = await (this as any).$refs.questionSet.CHECK_DATA_validate();
      if (!result) return;
      if (this.isAnswerMode) {
        this.setActiveIndex(this.activeIndex + 1);
      } else {
        await this.handleCommit();
      }
      return;
    }

    const result = await (this as any).$refs.questionSubmitSet.CHECK_DATA_validate();
    if (result) {
      await this.handleCommit();
    }
  }

  preNextClick() {
    this.setActiveIndex(this.activeIndex - 1);
  }

  // 保存后只抛出业务结果，由外层决定关闭弹窗或通知 iframe 宿主
  async handleCommit(submitScene: SubmitScene = "submit") {
    try {
      const data: any = await QuestionnaireEditModule.SAVE_QUESTIONNAIRE(this.basicDataUniqueId || "");
      this.submitLoading = false;
      this.emitStateChange();

      if (!data || !data.data || data.code != 200) {
        this.$message.error(data && data.message ? data.message : "提交失败");
        return "";
      }

      const questionnaireData = await QuestionnaireEditModule.GET_QUESTIONNAIRE_DETAIL(data.data);
      this.$message.success("提交成功");
      if (this.isAnswerMode) {
        const params = {
          templateId: "",
          title: this.basicData.title,
          questionnaireId: data.data,
          totalScore: this.basicData.totalScore,
          resultList: questionnaireData.resultList,
        };
        this.$emit("success", params, submitScene);
      } else {
        const params = {
          templateId: "",
          title: this.basicData.title,
          questionnaireId: data.data,
          participateUniqueCheck: questionnaireData.participateUniqueCheck,
          participateRepeatedClassId: questionnaireData.participateRepeatedClassId,
          participateRepeatedClassName: questionnaireData.participateRepeatedClassName,
        };
        this.$emit("success", params, submitScene);
      }
      return data.data;
    } catch (error) {
      this.submitLoading = false;
      this.emitStateChange();
      return "";
    }
  }

  mounted() {
    this.emitStateChange();
  }
}
